export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/feature-channel.3c531948-392ac7.png";